
export class AzureRmComponentUtilityConstants {
    public static Subscription: string = "Subscription";
    public static ManagementGroup: string = "Management Group";
    public static ResourceGroup: string = "Resource Group";
    public static EndpointFilterRule: string = "EndpointFilterRule";
    public static AzureRMEndpointDefaultFilterRule: string = "ScopeLevel != ManagementGroup && ScopeLevel != AzureMLWorkspace";
    public static deploymentScope: string = "deploymentscope";
}